<template>
  <cookie-control locale="en" />
</template>

<script setup lang="ts">
const client = useSupabaseClient();
const userStore = useUserStore();

const { isConsentGiven } = useCookieControl();

watch(isConsentGiven, async val => {
  if (val === false) {
    await client.auth.signOut();
    userStore.$reset();
    await navigateTo({ name: 'login' });
  }
});
</script>

<style>
.cookieControl__ControlButton {
  @apply bg-primary-500 hover:bg-primary-500 bottom-40 right-24;
}

.cookieControl__ControlButton svg {
  @apply text-white;
}
</style>
